const HEALTH_SAVINGS_SCRIPT_URL = "https://truemed-public.s3.us-west-1.amazonaws.com/truemed-ads/prequal-widget.min.js";
const HEALTH_SAVINGS_WIDGET_SELECTOR = "#truemed-prequalify";

const loadHealthSavingsWidget = () => {
  if (document.querySelector(`script[src="${HEALTH_SAVINGS_SCRIPT_URL}"]`)) return;
  const script = document.createElement("script");
  script.src = HEALTH_SAVINGS_SCRIPT_URL;
  script.defer = true;
  document.head.appendChild(script);
};

const initApexPanel = ($el) => {
  const productTemplate = $el.dataset.productTemplate;
  const panelHtmlByHandle = new Map();
  let requestedHandle = null;

  const state = window.Alpine.reactive({
    isLoading: false,
    hasError: false,
    shownHandle: null,
  });

  const getPanelBody = () => $el.querySelector("[data-apex-panel-body]");

  const buildPanelUrl = (handle) => {
    const storeRoot = window.Shopify?.routes?.root ?? "/";
    return `${storeRoot}products/${encodeURIComponent(handle)}?view=${encodeURIComponent(productTemplate)}`;
  };

  const loadPanelHtml = (handle) => {
    if (!panelHtmlByHandle.has(handle)) {
      const request = fetch(buildPanelUrl(handle), { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) throw new Error(`Product panel request failed: ${response.status}`);
          return response.text();
        })
        .catch((error) => {
          panelHtmlByHandle.delete(handle);
          throw error;
        });
      panelHtmlByHandle.set(handle, request);
    }
    return panelHtmlByHandle.get(handle);
  };

  const clearPanel = () => {
    const panelBody = getPanelBody();
    if (panelBody) panelBody.innerHTML = "";
    state.shownHandle = null;
  };

  const showProduct = async (handle) => {
    if (!handle || !productTemplate) return;
    if (handle === state.shownHandle || handle === requestedHandle) return;

    requestedHandle = handle;
    state.isLoading = true;
    state.hasError = false;
    clearPanel();

    try {
      const panelHtml = await loadPanelHtml(handle);
      if (requestedHandle !== handle) return;
      const panelBody = getPanelBody();
      if (!panelBody) return;
      panelBody.innerHTML = panelHtml;
      panelBody.scrollTop = 0;
      if (panelBody.querySelector(HEALTH_SAVINGS_WIDGET_SELECTOR)) loadHealthSavingsWidget();
      state.shownHandle = handle;
    } catch (error) {
      if (requestedHandle === handle) state.hasError = true;
      console.error(error);
    } finally {
      if (requestedHandle === handle) {
        state.isLoading = false;
        requestedHandle = null;
      }
    }
  };

  const syncPanel = (isOpen, handle) => {
    if (isOpen) showProduct(handle);
  };

  const closePanel = () => {
    window._stores.productDrawer.open = false;
  };

  const isVideoOpen = () => !!window._stores?.videoGallery?.open;

  const closeOnEscape = () => {
    if (isVideoOpen()) return;
    closePanel();
  };

  const isProductLink = (element) =>
    !!element?.closest?.('a[href]:not([href^="#"]), [role="button"][title^="/"]');

  const closeOnProductLink = (event) => {
    if (isProductLink(event.target)) closePanel();
  };

  return {
    panel: state,
    syncPanel,
    closePanel,
    closeOnEscape,
    closeOnProductLink,
    isVideoOpen,
  };
};

window._sections = window._sections || {};
window._sections["initApexPanel"] = initApexPanel;
